import { render, staticRenderFns } from "./ProjectReport.vue?vue&type=template&id=0d01b876&"
import script from "./ProjectReport.vue?vue&type=script&lang=ts&"
export * from "./ProjectReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports